module.exports = __webpack_public_path__ + "img/DB4-1920_09.ab00307c.jpg";